import React, { FC } from "react";

const NavItem: FC = ({ children }) => {
  return <div className={"flex border bg bg-white"}>{children}</div>;
};

export default NavItem;
